import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { reduxBatch } from "@manaflair/redux-batch";
import { rootReducer, rootSaga } from "./rootReducer";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

// Create the Saga middleware
const sagaMiddleware = createSagaMiddleware();

// Define middleware array
const middleware = (getDefaultMiddleware) => [
  ...getDefaultMiddleware({
    immutableCheck: false, // Disable immutable state check for performance
    serializableCheck: false, // Disable serializable state check if not needed
    thunk: true, // Disable thunk if you are not using it (you are using saga)
  }),
  sagaMiddleware, // Add saga middleware
];

// Configure the store with rootReducer, middleware, and enhancers
const store = configureStore({
  reducer: rootReducer, // Combined reducers
  middleware, // Middleware configuration
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in development mode
  enhancers: (getDefaultEnhancers) => {
    return [reduxBatch, ...getDefaultEnhancers()]
  }, // Add reduxBatch as enhancer
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
